import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentEmployee } from '../../../redux/slices/emloyeeSlice/employeeSlice';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import Brand from '../../../layout/Brand/Brand';
import User from '../../../layout/User/User';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import ThemeContext from '../../../contexts/themeContext';
import { dashboardPagesMenu } from '../../../menu';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const currentEmployee = useSelector((state: any) => state.employee.currentEmployee);
	const dispatch = useDispatch();

	const [pages, setPages] = useState();

	useEffect(() => {
		if (localStorage.getItem('token')) {
			//@ts-ignore
			dispatch(getCurrentEmployee());
		}
	}, []);

	useEffect(() => {
		if (currentEmployee && currentEmployee.data?.permissions) {
			const navigations = currentEmployee.data?.permissions;

			setPages(navigations);
		} else {
			//@ts-ignore
			setPages({});
		}
	}, [currentEmployee]);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<Navigation menu={dashboardPagesMenu} id='aside-dashboard' />
				<NavigationLine />
				<Navigation
					//@ts-ignore
					menu={{ ...pages }}
					id='aside-menu'
				/>
				<NavigationLine />
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
